(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaModule')
        .controller('grcActionPlanCriteriaEditModalController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'notificationService', 'followUpService', 'grcActionPlanCriteriaService', 'recomActionPlanUpdateStatusService'];

    function Controller($rootScope, $scope, $state, notificationService, followUpService, grcActionPlanCriteriaService, recomActionPlanUpdateStatusService) {

        $scope.ctrlCtxt = {
            isDirty: false
        };

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.isDirty = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        // Page is not dirty
        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.isDirty = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Show Delete Action?
        $scope.showDeleteAction = function () {
            return !_.isUndefined($scope.actionPlanCriteria.ActionPlanCriteriaID);
        };

        // Is TargetDate Read Only?
        $scope.isTargetDateReadOnly = function () {
            if ($scope.readOnly) return true;

            return $scope.actionPlanCriteria.IsTargetDateReadOnly;
        };

        // Update Action Plan Criteria/Deliverable
        $scope.updateActionPlanCriteria = function () {

            grcActionPlanCriteriaService
                .updateActionPlanCriteria($scope.actionPlanCriteria)
                .then(function () {
                    notificationService.notify('Your changes have been saved');
                    $state.reload();
                });
        };

        // Delete Action Plan Criteria/Deliverable
        $scope.deleteActionPlanCriteria = function () {
            grcActionPlanCriteriaService
                .deleteActionPlanCriteria($scope.actionPlanCriteria)
                .then(function () {
                    notificationService.notify('Action Plan Deliverable deleted successfully');
                    $scope.close(true);
                });
        };

        // Delete Active Assessment
        $scope.deleteActiveAssessment = function () {
            return grcActionPlanCriteriaService
                .deleteActiveAssessment($scope.actionPlanCriteria.ActionPlanCriteriaID)
                .then(function (updatedCriteria) {
                    $scope.actionPlanCriteria = updatedCriteria;
                    $scope.pageIsDirty();
                });
        };

        // Show open followUps action?
        $scope.showOpenFollowUpsAction = function () {
            if (!$scope.actionPlanCriteria.ActionPlanCriteriaID) return false;

            return !$scope.ctrlCtxt.isDirty;
        };

        // Open Followups
        $scope.openFollowups = function () {
            grcActionPlanCriteriaService
                .getFollowUpListByActionPlanCriteria(
                    $scope.actionPlanCriteria.ActionPlanID,
                    $scope.actionPlanCriteria.ActionPlanCriteriaID)
                .then(function (critAssContainers) {
                    followUpService.openFollowUpsModal($scope.actionPlanCriteria.TitleEN,
                                                      null,
                                                      null,
                                                      critAssContainers,
                                                      getDownloadAttachmentUrl);
                });
        };

        // Have dates the same day?
        $scope.haveDatesTheSameDay = function (date1, date2) {

            if (_.isUndefined(date1)) return;
            if (_.isUndefined(date2)) return;

            if (!moment.isMoment(date1)) date1 = moment(date1);
            if (!moment.isMoment(date2)) date2 = moment(date2);

            var isSameDay = date1.isSame(date2, 'day');
            return isSameDay;
        };

        function getDownloadAttachmentUrl(attachmentId, criteriaAssessment) {

            return recomActionPlanUpdateStatusService
                .getDownloadAttachmentUrl(
                    $scope.actionPlanCriteria.RecomBusinessUnitID,
                    $scope.actionPlanCriteria.ActionPlanID,
                    $scope.actionPlanCriteria.ActionPlanCriteriaID,
                    criteriaAssessment.ActionPlanCriteriaAssessmentID,
                    attachmentId);
        }

        // Cancel Modal
        $scope.cancel = function () {
            $scope.close();
            $scope.pageIsNotDirty();
        };

        // Update ActionPlan Criteria (Deliverable)
        $scope.updateActionPlanCriteria = function () {
            grcActionPlanCriteriaService
                .updateActionPlanCriteria($scope.actionPlanCriteria)
                .then(function (updatedActionPlanCriteria) {
                    $scope.close(true);
                    notificationService.notify('Your changes have been saved');
                    $scope.pageIsNotDirty();
                });
        };

    }
})();
